// Info: Import NPM Dependancies
import ConditionallyRender from 'react-conditionally-render';
import { useSelector } from 'react-redux';

// Info: Import Local Dependancies
import { callIfExists } from '../Chat/chatUtils';
import '../../assets/css/style.css';
import { ICustomComponents } from '../../interfaces/IConfig';
import { getChatContent } from '../../store/sitecoreSlice';

interface IUserChatMessageProps {
  message: string;
  customComponents: ICustomComponents;
}

const UserChatMessage = ({
  message,
  customComponents,
}: IUserChatMessageProps) => {
  const chatContent = useSelector(getChatContent)
  return (
    <div className="chatbot-profile-wrapper chatbot-profile-user">
      
      <ConditionallyRender
        condition={!!customComponents.userChatMessage}
        show={callIfExists(customComponents.userChatMessage, {
          message,
        })}
        elseShow={
         
           
            <div className="chatbot-profile-picture">
            <span> 
            {chatContent?.userIcon && <img src={chatContent.userIcon} alt="user image" />}
             
              </span>
            </div>
         
        }
      />
      <ConditionallyRender
        condition={!!customComponents.userAvatar}
        show={callIfExists(customComponents.userAvatar)}
        elseShow={
          <div className="chatbot-profile-content">
             <div className='chatbot-profile-title'> {chatContent?.userTitle}</div>
             <p className="chatbot-profile-chat"> {message}</p>
             
             
           
           
          </div>
        }
      />
    </div>
  );
};

export default UserChatMessage;
